import React, {
  Component,
  // Suspense, lazy
} from "react";
import { withApollo } from "react-apollo";

//import Campaign from "./partials/campaign";
import HeroSlider from "./HeroSlider";
import Programma from "./partials/programma_from_wp";
import Subscribe from "./partials/subscribe";
import Notikumi from "./partials/notikumi";
import Blogi from "./partials/blogi";
import ParMums from "./partials/parmums";
import Galerijas from "./partials/galerijas";
import Telpas from "./partials/telpas";
import Kontakti from "./partials/kontakti";
import FooterPage from "./partials/footerPage";
//import { frontpageScripts } from "./scripts/home";

import LoadingScreen from 'react-loading-screen';

// const Campaign = lazy(() => import('./partials/campaign'));
// const HeroSlider = lazy(() => import('./HeroSlider'));
// const Galerijas = lazy(() => import('./partials/galerijas'));
// const Subscribe = lazy(() => import('./partials/subscribe'));
// const Notikumi = lazy(() => import('./partials/notikumi'));
// const Blogi = lazy(() => import('./partials/blogi'));
// const ParMums = lazy(() => import('./partials/parmums'));
// const Telpas = lazy(() => import('./partials/telpas'));
// const Kontakti = lazy(() => import('./partials/kontakti'));
// const FooterPage = lazy(() => import('./partials/footerPage'));

class Frontpage extends Component {

  constructor() {
  super();
  this.state = {
    isLoading: true
  }
}

componentDidMount() {
  setTimeout(() => {
    this.setState({
      isLoading: false
    })
  }, 2000);
}

  render() {
    return (

      // this.state.isLoading ? console.log('loading') : console.log('loaded'),
      <React.Fragment>
  <LoadingScreen
    loading = {
      this.state.isLoading
    }
    bgColor='#000'
    spinnerColor = '#ecb527'
    textColor='#676767'
    logoSrc = 'https://kanepes.lv/wp-content/themes/kkc2020react/android-chrome-512x512.png'
  > 
          <HeroSlider />
          <iframe title="buklets" className="buklets_iframe" src="https://cdn.flipsnack.com/widget/v2/widget.html?hash=dcj4n9nd1j" seamless="seamless" scrolling="no" frameBorder="0" allowFullScreen allow="autoplay"></iframe>
          <Programma />
          <Subscribe />
          <Notikumi />
          <Blogi />
          <ParMums />
          <Galerijas />
          <Telpas />
          <Kontakti />
          <Subscribe />
          <FooterPage />
        </LoadingScreen>
        </React.Fragment>
    );
  }
}
export default withApollo(Frontpage);
